import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import CustomCursor from "@/components/CustomCursor";

export default function VerifyEmail() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState("loading");

    useEffect(() => {
    api.get(`/auth/verify-email/${token}`)
        .then(() => {
            setStatus("success");
            setTimeout(() => navigate("/dashboard"), 2000);
        })
        .catch((err) => {
            const status = err?.response?.status;
            // 400 = token déjà utilisé ou invalide, mais si l'user est connecté = déjà vérifié
            if (status === 400) {
                setStatus("success");
                setTimeout(() => navigate("/dashboard"), 2000);
            } else {
                setStatus("error");
            }
        });
}, [token, navigate]);

    return (
        <div style={{
            minHeight: "100vh",
            background: "linear-gradient(180deg, #07091f 0%, #0c1235 25%, #111840 50%, #1e1245 70%, #2a1550 100%)",
            display: "flex", alignItems: "center", justifyContent: "center",
        }}>
            <CustomCursor />
            <motion.div
                initial={{ opacity: 0, scale: 0.93 }}
                animate={{ opacity: 1, scale: 1 }}
                style={{
                    background: "rgba(255,255,255,0.07)",
                    backdropFilter: "blur(32px)",
                    border: "1px solid rgba(255,255,255,0.16)",
                    borderRadius: 16,
                    padding: "40px 36px",
                    textAlign: "center",
                    maxWidth: 380,
                    width: "100%",
                    margin: "0 16px",
                }}
            >
                {status === "loading" && (
                    <>
                        <div className="cyber-spinner mx-auto mb-4" />
                        <p style={{ color: "rgba(255,255,255,0.6)", fontFamily: "'DM Sans',sans-serif" }}>
                            Verifying your email…
                        </p>
                    </>
                )}
                {status === "success" && (
                    <>
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ type: "spring", stiffness: 180 }}
                            style={{
                                width: 56, height: 56, borderRadius: "50%",
                                background: "rgba(34,197,94,0.12)",
                                border: "1px solid rgba(34,197,94,0.35)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                margin: "0 auto 16px", fontSize: 24,
                            }}
                        >✓</motion.div>
                        <h2 style={{ color: "white", fontFamily: "'Syne',sans-serif", fontWeight: 800, marginBottom: 8 }}>
                            Email verified!
                        </h2>
                        <p style={{ color: "rgba(255,255,255,0.5)", fontFamily: "'DM Sans',sans-serif", fontSize: 14 }}>
                            Redirecting to dashboard…
                        </p>
                    </>
                )}
                {status === "error" && (
                    <>
                        <div style={{
                            width: 56, height: 56, borderRadius: "50%",
                            background: "rgba(239,68,68,0.12)",
                            border: "1px solid rgba(239,68,68,0.35)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            margin: "0 auto 16px", fontSize: 24,
                        }}>✗</div>
                        <h2 style={{ color: "white", fontFamily: "'Syne',sans-serif", fontWeight: 800, marginBottom: 8 }}>
                            Invalid link
                        </h2>
                        <p style={{ color: "rgba(255,255,255,0.5)", fontFamily: "'DM Sans',sans-serif", fontSize: 14, marginBottom: 24 }}>
                            This link is invalid or has expired.
                        </p>
                        <button
                            onClick={() => navigate("/login")}
                            style={{
                                width: "100%", padding: "12px",
                                background: "rgba(124,58,237,0.8)",
                                border: "1px solid rgba(124,58,237,0.5)",
                                borderRadius: 9, color: "white",
                                fontFamily: "'DM Sans',sans-serif",
                                fontWeight: 600, cursor: "pointer",
                            }}
                        >
                            Back to login
                        </button>
                    </>
                )}
            </motion.div>
        </div>
    );
}
